import { ActionHandler, ActionKey, MenuItem } from '../../Types'
import { ReactComponent as EditIcon } from 'assets/icons/edit16.svg'
import { HandbookItem } from 'types'

const createEditable = (textValue: string) => [{ key: ActionKey.edit, textValue, Icon: EditIcon }]

interface Editable {
  editable: MenuItem[]
  handleEdit: ActionHandler
}

export const useEditable = (_item: HandbookItem, actionLabel: string, onEdit?: () => void): Editable => {
  const handleEdit = (actionKey: ActionKey) => {
    if (actionKey !== ActionKey.edit) return false
    onEdit?.()
    return true
  }

  return {
    editable: createEditable(actionLabel),
    handleEdit,
  }
}
